<div class="dialog-header">
  <h2 mat-dialog-title>{{ "USER_ADMINISTRATION.PERMISSION_GROUPS" | translate }}</h2>
</div>

@if (isLoading$ | async) {
  <div style="display: flex; justify-content: center; align-items: center; padding: 20px;">
    <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50">
    </mat-progress-spinner>
  </div>
} @else {
  @if (defaultRoles$ | async; as defaultRoles) {
    @if (userCheckedDefaultRoles$ | async; as userCheckedDefaultRoles) {
      <form [formGroup]="defaultRolesForm">
        @for (defaultRole of defaultRoles; track defaultRole.id) {
          <div>
            <mat-checkbox [checked]="isChecked(userCheckedDefaultRoles, defaultRole)"
              (change)="onDefaultRoleChange($event, defaultRole)">
              {{ defaultRole.formattedName ?? defaultRole.name }}
            </mat-checkbox>
          </div>
        }
      </form>
      <br>

      <mat-dialog-actions align="center">
        <button mat-button color="primary" cdkFocusInitial (click)="close()">
          <mat-icon>check_circle</mat-icon> {{"ACTIONS.DONE" | translate}}
        </button>
      </mat-dialog-actions>
    }
  }
}
